export default __webpack_public_path__ + "static/050-6c4d9194a28bcac7b428b9db3df2f55f.jpg";